<div itemscope itemtype="https://schema.org/FAQPage" class="default-space-between-components rs-wrapper-v4">
    <h3>{{ 'title' | translate }}</h3>
    <mat-accordion displayMode="flat">
        <mat-expansion-panel itemscope itemprop="mainEntity" itemtype="https://schema.org/Question"
            *ngFor="let questionAnswer of questionAnswers" [expanded]="questionAnswer.showing">
            <mat-expansion-panel-header itemprop="name">
                <mat-panel-title>
                    <h5 [innerHTML]="questionAnswer.question | translate"></h5>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                <div itemprop="text">
                    <p [innerHTML]="questionAnswer.answer | translate"></p>
                </div>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
    <p [innerHTML]="'go_saldoar_blog_info' | translate"></p>
</div>
